import { useState, useEffect } from 'react';
import { useSearchParams, Link } from 'react-router-dom';
import axios from 'axios';
import { Button } from '@/components/ui/button';
import { CheckCircle, XCircle, Loader2 } from 'lucide-react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function PaymentSuccess() {
  const [searchParams] = useSearchParams();
  const sessionId = searchParams.get('session_id');
  const [status, setStatus] = useState('loading');
  const [attempts, setAttempts] = useState(0);

  useEffect(() => {
    if (!sessionId) { setStatus('error'); return; }

    const poll = async () => {
      try {
        const { data } = await axios.get(`${API}/payments/status/${sessionId}`);
        if (data.payment_status === 'paid') {
          setStatus('success');
        } else if (data.status === 'expired') {
          setStatus('expired');
        } else if (attempts < 5) {
          setTimeout(() => setAttempts(a => a + 1), 2000);
        } else {
          setStatus('pending');
        }
      } catch {
        if (attempts < 5) {
          setTimeout(() => setAttempts(a => a + 1), 2000);
        } else {
          setStatus('error');
        }
      }
    };
    poll();
  }, [sessionId, attempts]);

  return (
    <div className="min-h-screen flex items-center justify-center px-4 noise-bg" style={{ background: '#0F0F1A' }}>
      <div className="glass-card rounded-2xl p-8 max-w-md w-full text-center" data-testid="payment-result">
        {status === 'loading' && (
          <>
            <Loader2 className="w-16 h-16 text-[#7C3AED] mx-auto mb-4 animate-spin" />
            <h2 className="text-xl font-bold text-white mb-2" style={{ fontFamily: 'Outfit' }}>Vérification du paiement...</h2>
            <p className="text-[#94A3B8] text-sm">Veuillez patienter quelques instants</p>
          </>
        )}
        {status === 'success' && (
          <>
            <CheckCircle className="w-16 h-16 text-[#10B981] mx-auto mb-4" />
            <h2 className="text-xl font-bold text-white mb-2" style={{ fontFamily: 'Outfit' }}>Paiement réussi !</h2>
            <p className="text-[#94A3B8] text-sm mb-6">Votre compte Spin Review est maintenant actif. Connectez-vous pour configurer votre roue.</p>
            <Link to="/login">
              <Button className="btn-primary rounded-full px-8" data-testid="payment-login-btn">Accéder à mon dashboard</Button>
            </Link>
          </>
        )}
        {(status === 'error' || status === 'expired') && (
          <>
            <XCircle className="w-16 h-16 text-[#EF4444] mx-auto mb-4" />
            <h2 className="text-xl font-bold text-white mb-2" style={{ fontFamily: 'Outfit' }}>
              {status === 'expired' ? 'Session expirée' : 'Erreur de paiement'}
            </h2>
            <p className="text-[#94A3B8] text-sm mb-6">Le paiement n'a pas pu être confirmé. Veuillez réessayer.</p>
            <Link to="/#pricing">
              <Button className="btn-primary rounded-full px-8" data-testid="payment-retry-btn">Réessayer</Button>
            </Link>
          </>
        )}
        {status === 'pending' && (
          <>
            <Loader2 className="w-16 h-16 text-[#F59E0B] mx-auto mb-4" />
            <h2 className="text-xl font-bold text-white mb-2" style={{ fontFamily: 'Outfit' }}>Paiement en cours de traitement</h2>
            <p className="text-[#94A3B8] text-sm mb-6">Votre paiement est en cours de verification. Vous recevrez une confirmation bientot.</p>
            <Link to="/login">
              <Button className="btn-primary rounded-full px-8">Continuer</Button>
            </Link>
          </>
        )}
      </div>
    </div>
  );
}
